import React from 'react';

import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { LINK_EXPLANATION } from 'shared/constants/modal-constants';

type TLinkExplanationProps = {
  onClick: () => void;
};

export const LinkExplanation: React.FC<TLinkExplanationProps> = ({ ...props }) => {
  const { onClick } = props;
  return (
    <Stack direction="row" sx={{ pt: { lg: '96px', md: '40px', sm: '40px', xs: '40px' } }}>
      <Typography
        variant="caption"
        color="myGrey.grey400"
        width="270px"
        textAlign="center"
        sx={{ fontSize: { lg: 14, md: 12, sm: 12, xs: 12 } }}
      >
        {LINK_EXPLANATION.text}
        <Button
          variant="link"
          sx={{
            fontSize: { lg: 14, md: 12, sm: 12, xs: 12 },
            fontWeight: 700,
            padding: '0 0 2px 5px',
          }}
          onClick={onClick}
        >
          {LINK_EXPLANATION.button}
        </Button>
      </Typography>
    </Stack>
  );
};
